import './App.css';
import Theme from './utils/Theme';
import { BrowserRouter } from 'react-router-dom';
import Router from './utils/Router';
import AuthProvider from './contexts/AuthContext';
import NotificationProvider from './contexts/NotificationContext';
import PageProvider from './contexts/PageContext';
import TransactionProvider from './contexts/TransactionContext';
import CustomerProvider from './contexts/CustomerContext';
import LoadingProvider from './contexts/LoadingContext';
import IInventoryProvider from './contexts/InventoryContext'
import EmployeeProvider from './contexts/EmployeeContext';
import EcomTransactionProvider from './contexts/ecomOrderContext';


function App() {
  return (
    <div className="App">
      <LoadingProvider>
        <AuthProvider>
          <PageProvider>
            <TransactionProvider>
              <EcomTransactionProvider>
                <IInventoryProvider>
                  <CustomerProvider>
                    <EmployeeProvider>  
                      <Theme>
                        <NotificationProvider>
                          <BrowserRouter>
                            <Router />
                          </BrowserRouter>
                        </NotificationProvider>
                      </Theme>
                    </EmployeeProvider>
                  </CustomerProvider>
                </IInventoryProvider>
              </EcomTransactionProvider>
            </TransactionProvider>
          </PageProvider>
        </AuthProvider>
      </LoadingProvider>
    </div>
  );
}

export default App;
